import styled from 'styled-components'

import { white, mediumgray, black } from '../../styles/colors'
import { minmedia } from '../../styles/media-queries'

export const Container = styled.div`
  background-color: ${white};
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  position: relative;

  ${minmedia.large`
    padding: 1.5rem;
  `} ${minmedia.xxlarge`
    padding: 2rem;
  `};
`

export const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  margin: 0 auto;

  &::before {
    content: '';
    display: block;
    padding-top: 60%;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: contain;
    object-position: center center;
  }
`

export const TitleContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
${minmedia.large`
  font-size: 16px;
  margin: 1.5rem 0;
`};
`

export const Title = styled.div`
  font-size: 14px;
  text-align: center;
  font-weight: 300;
  line-height: 1.4;
  ${minmedia.large`
    font-size: 16px;
  `};
`

export const Description = styled.div`
  font-size: 12px;
  text-align: center;
  width: 100%;
  margin-bottom: 0.5rem;
  font-weight: 300;
  line-height: 1.4;
  color: ${mediumgray};
  ${minmedia.large`
    font-size: 15px;
  `};
`

export const InputContainer = styled.div`
  margin-top: auto; //force down
`

export const ProductCode = styled.div`
  font-size: 14px;
  font-weight: 300;
  width: 100%;
  margin-bottom: 0.5rem;
  text-align: right;
  color: ${mediumgray};
`

export const OrderAmount = styled.div`
  text-align: center;
  border: 1px solid ${black};
  padding: 0.5rem 2.5rem;
  display: inline-block
  margin: 0 auto;
  border-radius: 2.5rem;
  font-size: 14px;
`



// WEBPACK FOOTER //
// ./src/components/Product/styles.js